import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Column, eColumnType, TableConfig } from './mot-table-config.interface';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'mot-table',
    templateUrl: './mot-table.component.html',
    styleUrls: ['./mot-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MotTableComponent<T>{
  @Input() class: string;
  /**
   * a11y: alt text for the empty-state illustration. Callers should pass a
   * localized string. Falls back to an English description if not provided
   * so the image is never announced as "image" with no context.
   */
  @Input() emptyAlt: string = 'No data to display';
  columnTypes = eColumnType;

  _config: TableConfig<T>;
  _data: MatTableDataSource<T> = new MatTableDataSource<T>();
  displayedColumns: string[] = [];
  selectedRow: T;

  @Input() set config(val: TableConfig<T>) {
    this.displayedColumns = [
      ...this.displayedColumns,
      ...val.Columns.map((col) => col.columnId),
    ];

    this._config = val;
  }

  @Input() set dataSource(val: T[]) {
    this._data.data = val;
  }

  get hasSingleRow(): boolean {
    return this._data?.data?.length === 1;
  }

  get hasMultipleRows(): boolean {
    return (this._data?.data?.length ?? 0) > 1;
  }

  getCellClass(element: T, column: Column<T>): string | string[] {
    if (column.cellClass) {
      if (
        typeof column.cellClass === 'string' ||
        Array.isArray(column.cellClass)
      ) {
        return column.cellClass;
      } else if (typeof column.cellClass === 'function') {
        return column.cellClass(element);
      }
    }

    return null;
  }

  getHeaderCellClass(column: Column<T>): string | string[] {
    if (column.headerClass) {
      if (
        typeof column.headerClass === 'string' ||
        Array.isArray(column.headerClass)
      ) {
        return column.headerClass;
      } else if (typeof column.headerClass === 'function') {
        return column.headerClass();
      }
    }

    return null;
  }

  iconAssetUrl(iconName: string | null): string {
    return `/assets/icons/${iconName}.svg`;
  }

  getCellStyles(
    element: T,
    column: Column<T>
  ): { [klass: string]: any } | { [klass: string]: any }[] {
    if (column.cellStyles) {
      if (
        typeof column.cellStyles === 'object' ||
        Array.isArray(column.cellStyles)
      ) {
        return column.cellStyles;
      } else if (typeof column.cellStyles === 'function') {
        return column.cellStyles(element);
      }
    }

    return null;
  }
}
